import Vue from 'vue'
import Router from 'vue-router'


import Home from '@/components/home/Home'
import HomeDefault from '@/components/home/HomeDefault'
import About from '@/components/home/About'
import Services from '@/components/home/Services'
import Resources from '@/components/home/Resources'
import Contact from '@/components/home/Contact'
import DownloadApp from '@/components/DownloadApp'
import DownloadCandidateApp from '@/components/DownloadCandidateApp'
import Debug from '@/components/Debug'

import Login from '@/components/file/Login'
import Signup from '@/components/file/Signup'
import Account from '@/components/file/Account'
import Verify from '@/components/file/Verify'
import OwnCloud from '@/components/file/OwnCloud'
import Logs from '@/components/file/Logs'
import Permissions from '@/components/file/Permissions'

import Forgot_Password from '@/components/file/Forgot_Password'
import Password_Reset from '@/components/file/Password_Reset'

import Job_Orders from '@/components/view/Job_Orders'
import Employee_Hours from '@/components/view/Employee_Hours'
import Employee_Overview from '@/components/view/Employee_Overview'
import Unassigned_Documents from '@/components/view/Unassigned_Documents'
import Job_Orders_Pictures from '@/components/view/Job_Orders_Pictures'
import Job_Orders_Files from '@/components/view/Job_Orders_Files'
import View_Job_Orders from '@/components/view/View_Job_Orders'
import View_Schedules from '@/components/view/View_Schedules'
import Vessels from '@/components/view/Vessels'
import Vessel_History from '@/components/view/Vessel_History'
import View_Vessel_History from '@/components/view/View_Vessel_History'
import View_Documents from '@/components/view/View_Documents'
import Invoices from '@/components/view/Invoices'
import View_Invoices from '@/components/view/View_Invoices'
import Scheduling from '@/components/view/Scheduling'
import PO_Numbers from '@/components/view/PO_Numbers'
import View_PO_Numbers from '@/components/view/View_PO_Numbers'
import Invoice_Status from '@/components/view/Invoice_Status'
import Job_Order_Port_Stays from '@/components/view/Job_Order_Port_Stays'
import Contracts from '@/components/view/Contracts'
import View_Contracts from '@/components/view/View_Contracts'
import Graphs from '@/components/view/Graphs'
import Inventory from '@/components/view/Inventory'
import Inventory_Assign from '@/components/view/Inventory_Assign'
import View_Inventory from '@/components/view/View_Inventory'
import Inventory_Boxes from '@/components/view/Inventory_Boxes'
import Timesheets from '@/components/view/Timesheets'
import Scheduling_V2 from '@/components/view/Scheduling_V2'
import Timesheet_Map from '@/components/view/Timesheet_Map'
import Trips from '@/components/view/Trips'
import View_Timesheet_History from '@/components/view/View_Timesheet_History'

import Add_Job_Orders from '@/components/add/Add_Job_Orders'
import Add_Vessels from '@/components/add/Add_Vessels'
import Add_Documents from '@/components/add/Add_Documents'
import Add_Techdocs from '@/components/add/Add_Techdocs'
import Add_Pictures from '@/components/add/Add_Pictures'
import Add_Files from '@/components/add/Add_Files'
import Add_Subcontractor_Hours from '@/components/add/Add_Subcontractor_Hours'
import Add_PO_Numbers from '@/components/add/Add_PO_Numbers'
import Add_Invoice_Prep from '@/components/add/Add_Invoice_Prep'
import Add_Port_Stays from '@/components/add/Add_Port_Stays'
import Add_Inventory_Item from '@/components/add/Add_Inventory_Item'
import Scan_Inventory_Item from '@/components/add/Scan_Inventory_Item'
import Add_Issues from '@/components/add/Add_Issues'
import Add_Trips from '@/components/add/Add_Trips'

import Edit_Job_Orders from '@/components/edit/Edit_Job_Orders'
import Edit_Job_Schedules from '@/components/edit/Edit_Job_Schedules'
import Edit_Documents from '@/components/edit/Edit_Documents'
import Edit_Vessels from '@/components/edit/Edit_Vessels'
import Edit_Techdocs from '@/components/edit/Edit_Techdocs'
import Edit_Subcontractor_Hours from '@/components/edit/Edit_Subcontractor_Hours'
import Delete_Files from '@/components/edit/Delete_Files'
import Delete_Pictures from '@/components/edit/Delete_Pictures'
import Edit_PO_Number_Job_Orders from '@/components/edit/Edit_PO_Number_Job_Orders'
import Edit_Additional_Job_Orders from '@/components/edit/Edit_Additional_Job_Orders'
import Edit_Inventory_Items from '@/components/edit/Edit_Inventory_Items'
import Edit_Inventory_Boxes from '@/components/edit/Edit_Inventory_Boxes'
import Edit_PO_Numbers from '@/components/edit/Edit_PO_Numbers'
import Edit_Service_Reports from '@/components/edit/Edit_Service_Reports'
import Edit_Invoice from '@/components/edit/Edit_Invoice'
import Edit_Website from '@/components/edit/Edit_Website'
import Edit_Employees from '@/components/edit/Edit_Employees'
import Assign_Document_WO from '@/components/edit/Assign_Document_WO'
import Edit_Box_Items from '@/components/edit/Edit_Box_Items'
import Edit_Trips from '@/components/edit/Edit_Trips'
import Merge_Documents from '@/components/edit/Merge_Documents'

import Reports from '@/components/view/Reports'
import Status from '@/components/view/Status'

import Proxy from '@/Proxy'
import Emails from '@/components/file/Emails'


import Layout1 from '@/layouts/layout_1'
import Layout2 from '@/layouts/layout_2'
import Layout3 from '@/layouts/layout_3'
import Layout4 from '@/layouts/layout_4'
import Layout5 from '@/layouts/layout_5'
import Layout6 from '@/layouts/layout_6'
import Layout7 from '@/layouts/layout_7'
import Layout8 from '@/layouts/layout_8'
import Layout9 from '@/layouts/layout_9'
import Layout10 from '@/layouts/layout_10'
import Layout11 from '@/layouts/layout_11'
import Layout12 from '@/layouts/layout_12'
import Layout13 from '@/layouts/layout_13'
import Layout14 from '@/layouts/layout_14'
import Layout15 from '@/layouts/layout_15'
import Autocomplete from '@/layouts/autocomplete'
import Datetime from '@/layouts/datetime'
import Jobtype from '@/layouts/jobtype'
import Document from '@/layouts/document'
import Vesselpic from '@/layouts/vesselpic'
import Invoice from '@/layouts/invoice'
import Techdoc from '@/layouts/techdoc'
import Timetable from '@/layouts/timetable'
import Timetable_Overview from '@/layouts/timetable_overview'
import Filtr from '@/layouts/filter'
import Dialogue from '@/layouts/dialogue'
import Comments from '@/layouts/comments'
import UploadInvoice from '@/layouts/upload_invoice'
import ScheduleDialog from '@/layouts/schedule_dialog'
import Chart from '@/layouts/chart'
import Inventorypics from '@/layouts/inventorypics'
import CheckItem from '@/layouts/checkitem'
import RadioStatus from '@/layouts/status'

Vue.use(Router);
Vue.component('layout-1', Layout1);
Vue.component('layout-2', Layout2);
Vue.component('layout-3', Layout3);
Vue.component('layout-4', Layout4);
Vue.component('layout-5', Layout5);
Vue.component('layout-6', Layout6);
Vue.component('layout-7', Layout7);
Vue.component('layout-8', Layout8);
Vue.component('layout-9', Layout9);
Vue.component('layout-10', Layout10);
Vue.component('layout-11', Layout11);
Vue.component('layout-12', Layout12);
Vue.component('layout-13', Layout13);
Vue.component('layout-14', Layout14);
Vue.component('layout-15', Layout15);
Vue.component('autocomplete', Autocomplete);
Vue.component('datetime', Datetime);
Vue.component('jobtype', Jobtype);
Vue.component('document', Document);
Vue.component('vesselpic', Vesselpic);
Vue.component('invoice', Invoice);
Vue.component('techdoc', Techdoc);
Vue.component('timetable', Timetable);
Vue.component('timetable-overview', Timetable_Overview);
Vue.component('filtr', Filtr);
Vue.component('dialogue', Dialogue);
Vue.component('comments', Comments);
Vue.component('upload-invoice', UploadInvoice);
Vue.component('schedule-dialog', ScheduleDialog);
Vue.component('chart', Chart);
Vue.component('inventorypics', Inventorypics);
Vue.component('checkitem', CheckItem);
Vue.component('status', RadioStatus);
Vue.component('timesheet-history', View_Timesheet_History);

export default new Router({
	routes: [
		{
			path: '/home',
			name: 'Home',
			component: Home,
            children: [
                {
                    path: '',
                    component: HomeDefault
                },
                {
                    path: 'about',
                    component: About
                },
                {
                    path: 'services',
                    component: Services
                },
                {
                    path: 'resources',
                    component: Resources
                },
                {
                    path: 'contact',
                    component: Contact
                }
            ]
		},
		{
			path: '/downloadapp',
			name: 'Download App',
			component: DownloadApp
		},
		{
			path: '/downloadcandidateapp',
			name: 'Download Candidate App',
			component: DownloadCandidateApp
		},
		{
			path: '/199',
			name: 'Debug',
			component: Debug
		},
		{
			path: '/0200',
			name: 'Login',
			component: Login
		},
		{
			path: '/0201',
			name: 'Signup',
			component: Signup
		},
		{
			path: '/0202',
			name: 'Verify',
			component: Verify,
			props: (route) => ({krypto:route.query.q})
		},
		{
			path: '/0203',
			name: 'Forgot Password',
			component: Forgot_Password
		},
		{
			path: '/0204',
			name: 'Password Reset',
			component: Password_Reset,
			props: (route) => ({krypto:route.query.q})
		},
		{
			path: '/0205',
			name: 'Account',
			component: Account
		},
		{
			path: '/0206',
			name: 'LDPA Cloud',
			component: OwnCloud
		},
		{
			path: '/0207',
			name: 'Logs',
			component: Logs,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0208',
			name: 'Permissions',
			component: Permissions,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0300',
			name: 'Job Orders',
			component: Job_Orders,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0301',
			name: 'View Job Order',
			component: View_Job_Orders,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0302',
			name: 'Employee Hours',
			component: Employee_Hours,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0303',
			name: 'Unassigned Documents',
			component: Unassigned_Documents,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0304',
			name: 'View Schedule',
			component: View_Schedules,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0305',
			name: 'Vessels',
			component: Vessels,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0306',
			name: 'View Document',
			component: View_Documents,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0307',
			name: 'Employee Overview',
			component: Employee_Overview,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0308',
			name: 'Invoices',
			component: Invoices,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0309',
			name: 'View Invoice',
			component: View_Invoices,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0310',
			name: 'Scheduling',
			component: Scheduling,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0311',
			name: 'Vessel History',
			component: Vessel_History,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0312',
			name: 'View Vessel History',
			component: View_Vessel_History,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0313',
			name: 'Pictures',
			component: Job_Orders_Pictures,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0314',
			name: 'Files',
			component: Job_Orders_Files,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0315',
			name: 'PO Numbers',
			component: PO_Numbers,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0316',
			name: 'View PO Numbers',
			component: View_PO_Numbers,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0317',
			name: 'Invoice Status',
			component: Invoice_Status,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0318',
			name: 'Job Order Port Stays',
			component: Job_Order_Port_Stays,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0319',
			name: 'Contracts',
			component: Contracts,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0320',
			name: 'View Contracts',
			component: View_Contracts,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0321',
			name: 'Dashboard',
			component: Graphs,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0322',
			name: 'Inventory',
			component: Inventory,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0323',
			name: 'Inventory Assign',
			component: Inventory_Assign,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0324',
			name: 'Inventory Item',
			component: View_Inventory,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0325',
			name: 'Boxes',
			component: Inventory_Boxes,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0326',
			name: 'Timesheets',
			component: Timesheets,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0327',
			name: 'Edit Service Reports',
			component: Edit_Service_Reports,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0328',
			name: 'Edit Website HTML',
			component: Edit_Website
		},
		{
			path: '/0329',
			name: 'Scheduling',
			component: Scheduling_V2
		},
		{
			path: '/0330',
			name: 'Map',
			component: Timesheet_Map
		},
		{
			path: '/0331',
			name: 'Edit Employees',
			component: Edit_Employees
		},
		{
			path: '/0332',
			name: 'Assign Document WO',
			component: Assign_Document_WO
		},
		{
			path: '/0333',
			name: 'Edit Box Items',
			component: Edit_Box_Items
		},
		{
			path: '/0334',
			name: 'Trips',
			component: Trips,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0335',
			name: 'Approve Documents',
			component: Merge_Documents,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0400',
			name: 'Add Job Order',
			component: Add_Job_Orders
		},
		{
			path: '/0401',
			name: 'Add Vessel',
			component: Add_Vessels
		},
		{
			path: '/0402',
			name: 'Add Document',
			component: Add_Documents
		},
		{
			path: '/0403',
			name: 'Add Tech Document',
			component: Add_Techdocs,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0404',
			name: 'Add Picture',
			component: Add_Pictures,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0405',
			name: 'Add File',
			component: Add_Files,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0406',
			name: 'Add Subcontractor Hours',
			component: Add_Subcontractor_Hours,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0407',
			name: 'Add PO Numbers',
			component: Add_PO_Numbers
		},
		{
			path: '/0408',
			name: 'Report Prep',
			component: Add_Invoice_Prep,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0409',
			name: 'Add To Port Stay',
			component: Add_Port_Stays,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0410',
			name: 'Add Inventory Item',
			component: Add_Inventory_Item,
		},
		{
			path: '/0411',
			name: 'Scan Inventory Item',
			component: Scan_Inventory_Item,
		},
		{
			path: '/0412',
			name: 'Submit Troubleticket',
			component: Add_Issues,
		},
		{
			path: '/0413',
			name: 'Add Trip',
			component: Add_Trips
		},
		{
			path: '/0500',
			name: 'Edit Job Order',
			component: Edit_Job_Orders,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0501',
			name: 'Edit Job Schedule',
			component: Edit_Job_Schedules,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0502',
			name: 'Edit Document',
			component: Edit_Documents,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0503',
			name: 'Edit Vessel',
			component: Edit_Vessels,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0504',
			name: 'Edit Tech Document',
			component: Edit_Techdocs,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0505',
			name: 'Delete Files',
			component: Delete_Files,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0506',
			name: 'Delete Pictures',
			component: Delete_Pictures,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0507',
			name: 'Edit Subcontractor Hours',
			component: Edit_Subcontractor_Hours,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0508',
			name: 'Edit PO Number Job Orders',
			component: Edit_PO_Number_Job_Orders,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0509',
			name: 'Edit Additional Job Orders',
			component: Edit_Additional_Job_Orders,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0510',
			name: 'Edit Inventory Item',
			component: Edit_Inventory_Items,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0511',
			name: 'Edit Inventory Box',
			component: Edit_Inventory_Boxes,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0512',
			name: 'Edit PO Number',
			component: Edit_PO_Numbers,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0513',
			name: 'Edit Invoice',
			component: Edit_Invoice,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0514',
			name: 'Edit Trip',
			component: Edit_Trips,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0600',
			name: 'Reports',
			component: Reports
		},
		{
			path: '/0601',
			name: 'Status',
			component: Status,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0700',
			name: 'Proxy',
			component: Proxy,
			props: (route) => ({term:route.query.q})
		},
		{
			path: '/0701',
			name: 'Emails',
			component: Emails,
			props: (route) => ({term:route.query.q})
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js